'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _selectedThreadActionTypes = require('../constants/selectedThreadActionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = null;

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _selectedThreadActionTypes.SELECT_THREAD, function (state, action) {
  var threadId = action.payload.threadId;


  return threadId;
}), _defineProperty(_handleActions, _selectedThreadActionTypes.CLEAR_SELECTED_THREAD, function () {
  return initialState;
}), _handleActions), initialState);
module.exports = exports['default'];